import {
  useUpdateLocationMutation,
  updateLocationRequest,
} from 'features/stock/store/endpoint/update-location';
import Stocklocation from 'features/stock/types/stock-location';
import loadData from 'features/table/slice/actions/load-data';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import {selectActiveModalParams} from 'store/ui/selectors';
import {uiActions} from 'store/ui/ui-slice';

const __DEV__ = process.env.NODE_ENV === 'development';

export const useLocationForm = () => {
  const [submit, {isLoading, error}] = useUpdateLocationMutation();

  const serverError = parseValidationErrors(error);

  const modalParams = useSelector(selectActiveModalParams);
  const stockLocation = modalParams?.stockLocation as Stocklocation;

  const [params, setParams] = useState<Params>({
    id: stockLocation?.id,
    name: stockLocation?.name,
    stock_location_category: stockLocation?.stock_location_category,
    is_locked: stockLocation?.is_locked,
  });

  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const result = await submit(params);
    if ('data' in result) {
      dispatch(loadData({name: 'stock-locations', page: 1}));
      dispatch(uiActions.dismissModalWithResult(result.data.data));
    }
  };

  return {
    setParams,
    params,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
  };
};

type Params = updateLocationRequest;
